import { ICONS } from '@/components/icons/icons'

import { AuthShell } from './AuthShell'
import styles from './AuthShell.module.css'
import { signOut } from './identityAuth'

interface NoAccessScreenProps {
  /** The signed-in account, when known. */
  email: string | null
  /** The API's reason (e.g. a non-RBI account), shown under the main explanation. */
  detail?: string | null
}

async function signOutAndRestart(): Promise<void> {
  await signOut()
  window.location.assign('/')
}

function handleSignOut(): void {
  void signOutAndRestart()
}

function handleRetry(): void {
  window.location.reload()
}

/** Shown when the API refuses entry (403): signed in, but not an FPA user (or not an RBI account). */
export function NoAccessScreen({ email, detail }: NoAccessScreenProps) {
  const notRbi = detail?.includes('only available to') ?? false
  return (
    <AuthShell icon="lock" tone="bad" title="No access to FP&A">
      <p className={styles.text}>
        {notRbi
          ? 'FP&A is only available to RBI Private Lending accounts. Sign out and sign in with your RBI Microsoft account.'
          : 'You are signed in, but your account has not been given access to FP&A yet.'}
      </p>
      {notRbi ? null : (
        <p className={styles.text}>
          Ask an FPA admin to add you from <strong>Access</strong>, then try again.
        </p>
      )}
      <div className={styles.identity}>
        <ICONS.users size={16} className={styles.identityIcon} />
        <div>
          <div className={styles.identityLabel}>Signed in as</div>
          <div className={styles.identityEmail}>{email ?? 'Unknown account'}</div>
        </div>
      </div>
      <div className={styles.actions}>
        <button type="button" className={styles.primary} onClick={handleRetry}>
          <ICONS.refresh size={14} />
          Try again
        </button>
        <button type="button" className={styles.secondary} onClick={handleSignOut}>
          <ICONS.logout size={14} />
          Sign out
        </button>
      </div>
    </AuthShell>
  )
}
